import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/primeng';
import { LocalStorageService } from 'ng2-webstorage';
import { MessageService } from 'primeng/components/common/messageservice';
import { ParentChildService } from '../parentchild-advanceQ.service';



@Component({
  selector: 'studentregQ',
  templateUrl: 'studentregQ.component.html',
  styleUrls: ['studentregQ.component.scss']
})

export class AddstudentregQComponent implements OnInit {
  public schoolId: any;
  public department: any;
  display = "none"
  public departmentList: any;
  public info:boolean=false;
  //public userId: any;


  public HigherEdchildcourse: any;
  public HigherEdchildBatch: any;
  public selectedCourse: string = '';
  public selectedbatch: string = '';

  public studentfname: string = '';
  public studentmname: string = '';
  public studentlname: string = '';
  public studentdob: string = '';
  public studentnic: string = '';
  public studentemail: string = '';
  public studentgender: string = '';
  public studentphone: string = '';
  public studentcreateddate: Date = new Date();
  public studentModifieddate: Date = new Date();
  public stucreatedby: string = ''
  public stumodifiedby: string = ''
  public stustatusid: string = '1'
  public studentcode: string = '';


  


 
  constructor(private messageService: MessageService, private parentchildservice: ParentChildService,private confirmationService: ConfirmationService, private localStorage: LocalStorageService) 
  {
    this.schoolId = this.localStorage.retrieve('schoolid');
    //this.userId = this.localStorage.retrieve('CurrentChildId');
  }

  ngOnInit() { 
    this.GetCourseList();

  }
//-------------------------------------------------------------------------------------------------

private GetCourseList(){
  this.parentchildservice.getHigherEdChildCourseList().finally(() => { }).subscribe(
    response => {
      this.HigherEdchildcourse = response['items'];
      console.log('HigherEdchildcourse',this.HigherEdchildcourse)
    },
    error => {
      console.error(error);
    });
};

changecourse() {
  console.log("courseT",this.selectedCourse)
  this.GetBatchList();
 };
//----------------------------------------------------------------------------------
 private GetBatchList(){
  this.parentchildservice.getHigherEdChildBatchList(this.selectedCourse).finally(() => { }).subscribe(
    response => {
      this.HigherEdchildBatch = response['Value'];
      console.log('HigherEdchildBatch',this.HigherEdchildBatch)
    },
    error => {
      console.error(error);
    });
};

changebatch() {
  console.log("batchT",this.selectedbatch)
 };
//--------------------------------------------------------------------------------------

 postStudentInfo() {
  var payload = {
    
      Code: this.studentcode,
      Firstname: this.studentfname,
      Lastname: this.studentlname,
      Middlename: this.studentmname,
      Dob: this.studentdob,
      Phonenumber: this.studentphone,
      Genderid: this.studentgender,
      Createddate: this.studentcreateddate,
      Modifieddate: this.studentModifieddate,
      Createdby: /*this.stucreatedby*/this.schoolId,
      Modifiedby: /*this.stumodifiedby*/this.schoolId,
      Statusid: this.stustatusid,
      Email: this.studentemail,
      Nic: this.studentnic,
      BatchCourseMappingId: this.selectedbatch
      
    
  };
  
  console.log("postStudentInfo",payload);
  
  this.parentchildservice
  .postHiEduChildInfo(payload)
  .finally(() => {})
  .subscribe(
    (response) => {
      this.messageService.add({
        severity: "success",
        summary: "Talkative Parents",
        detail: "Student Added Successfully",
      });
      this.display = "none";
      //this.ShowCourse();
      this.clearFormData();

      console.log(response);
    },
    (error) => {}
  );
};

clearFormData() {
  this.selectedCourse ='';
  this.studentcode = '';
  this.studentfname = '';
  this.studentlname = '';
  this.studentmname = '';
  this.studentdob = '';
  this.studentphone = '';
  this.studentgender = '';
  this.studentcreateddate = new Date();
  this.studentModifieddate = new Date();
  this.studentemail = '';
  this.studentnic = '';
  this.selectedbatch = '';
}

 //----------------------------------------------------------------------------------------------

roleinfo(){
  this.info=true;
 }


editSemsub(semsub){
 this.departmentList.filter(ele=>{
   if(ele.Id==semsub.Id){
    
     // this.display = true;
     this.display = "block";
   }
 })
}


addSemsub() {

 this.display= "block"
 // this.display = true;
}
onCloseHandled() {
 this.display= "none";
}
}


// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/parentchild/studentreg/studentregQ.component.ts